/**
 * CenterSelector - Layout 헤더에 표시되는 center 선택 드롭다운
 *
 * - center가 없으면 "센터를 생성해주세요" 메시지 표시
 * - center가 하나이면 이름만 텍스트로 표시 (드롭다운 불필요)
 * - center가 여러 개이면 select 드롭다운으로 전환 가능
 */

import { Link } from "react-router-dom";
import { useCenterContext } from "@/contexts/CenterContext";

export function CenterSelector() {
  const { currentCenter, centers, isLoading, selectCenter } = useCenterContext();

  if (isLoading) {
    return <div className="animate-pulse h-8 w-32 bg-gray-200 rounded" />;
  }

  // Center가 없는 경우
  if (centers.length === 0) {
    return (
      <Link
        to="/centers"
        className="text-sm text-orange-600 font-medium hover:text-orange-800 hover:underline cursor-pointer"
      >
        센터를 생성해주세요
      </Link>
    );
  }

  // Center가 하나뿐인 경우 - 텍스트로만 표시
  if (centers.length === 1) {
    return <span className="text-sm font-medium text-gray-700">{centers[0].name}</span>;
  }

  // Center가 여러 개인 경우 - 드롭다운
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const centerId = Number(e.target.value);
    if (centerId) {
      selectCenter(centerId);
    }
  };

  return (
    <select
      value={currentCenter?.centerId ?? ""}
      onChange={handleChange}
      className="text-sm font-medium text-gray-700 border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
      aria-label="센터 선택"
    >
      {!currentCenter && <option value="">센터 선택</option>}
      {centers.map((center) => (
        <option key={center.centerId} value={center.centerId}>
          {center.name}
        </option>
      ))}
    </select>
  );
}
